export default __webpack_public_path__ + "static/media/Conscript's Belt of the Eastern Sun.2b7becd3.jpg";